import { TenantEntity } from '../TenantEntity'

export class AutomationCommand extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get name() {
    return this._data.name
  }
  set name(name) {
    this._data.name = name
  }
  get commandName() {
    return this._data.commandName
  }
  set commandName(commandName) {
    this._data.commandName = commandName
  }
  get dataScript() {
    return this._data.dataScript
  }
  set dataScript(dataScript) {
    this._data.dataScript = dataScript
  }
}
